import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

const ICONS = {
  dashboard: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path d="M4 11.5 12 4l8 7.5V19a1 1 0 0 1-1 1h-4.5v-6h-5v6H5a1 1 0 0 1-1-1z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  ),
  testcases: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <rect x="5.5" y="4.5" width="13" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <line x1="8.5" y1="9.5" x2="15.5" y2="9.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="8.5" y1="13" x2="15.5" y2="13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="8.5" y1="16.5" x2="13" y2="16.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  execution: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path d="M7 4.7v14.6a1 1 0 0 0 1.53.85l11.6-7.3a1 1 0 0 0 0-1.7L8.53 3.85A1 1 0 0 0 7 4.7z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  ),
  reports: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <rect x="4.5" y="12.5" width="4" height="7" rx="1" stroke="currentColor" strokeWidth="1.8" />
      <rect x="10" y="7.5" width="4" height="12" rx="1" stroke="currentColor" strokeWidth="1.8" />
      <rect x="15.5" y="3.5" width="4" height="16" rx="1" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  ),
};

const ALL_NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: 'dashboard', roles: ['admin', 'qa', 'dev', 'product', 'staff'] },
  { to: '/projects', label: 'Projects', icon: 'testcases', roles: ['admin', 'qa', 'dev', 'product'] },
  { to: '/test-execution', label: 'Execution', icon: 'execution', roles: ['admin', 'qa', 'dev', 'product'] },
  { to: '/reports', label: 'Reports', icon: 'reports', roles: ['admin', 'qa', 'dev', 'product', 'staff'] },
];

function Navigation({ user }) {
  const role = user?.role || 'staff';
  const navItems = ALL_NAV_ITEMS.filter((item) => item.roles.includes(role));

  return (
    <aside className="sidebar-shell">
      <nav className="sidebar-nav" aria-label="Primary navigation">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => `sidebar-link${isActive ? ' is-active' : ''}`}
          >
            <span className="sidebar-link-icon" aria-hidden="true">{ICONS[item.icon]}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default Navigation;
